/**
 * Получает массив UTM-параметров из текущей строки запроса.
 */
function getUtmParameters(): string[]
{
	return window.location.search.substr( 1 )
		.split( '&' )
		.filter(
			( item ) => (
				( item.substr( 0, 4 ) === 'utm_' )
				|| ( item.substr( 0, 10 ) === 'calltouch_' )
			),
		);
}

/**
 * Module.
 */
export {
	getUtmParameters as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/getUtmParameters.ts